import Cookies from 'quasar/src/plugins/Cookies.js';
import {ICookies} from '@/interface'
import {CookiesEnum} from '@/enums'
import analytics from "@/analytics/analytics";

const megaCookieName = 'megacookie_telco'

export const hasMegaCookie = () => {
    return Cookies.has(megaCookieName)
}

export const initMegaCookie = () => {
    const hasIt = Cookies.has(megaCookieName)
    if (!hasIt) {
        writeCookie(megaCookieName, JSON.stringify({necessary: true, statistic: true, marketing: true} as ICookies))
    }
}

export const isStatisticCookieAccepted = () => {
    if (!Cookies.has(megaCookieName)) {
        return false
    }
    
    return getMegaCookieValue(CookiesEnum.analytics) as boolean
}

export const getMegaCookieValue = (parameter: string): boolean => {
    const megacookie = Cookies.get(megaCookieName)
    if (megacookie) {
        const json = Object.assign({} as ICookies, megacookie)
        return json[parameter] 
    }

    return false
}

export const setMegaCookieValue = (parameter: string, value: boolean) => {
    const megacookie = Cookies.get(megaCookieName)
    if (!megacookie) {
      return 
    }

    const json = Object.assign({} as ICookies, megacookie)
    json[parameter] = value

    // Then write the cookie.
    writeCookie(megaCookieName, JSON.stringify(json));
    analytics.logEvent(`coockiesEdit`, json);
}

export const setMegaCookieValues = (analytics: boolean, ads: boolean) => {
    writeCookie(megaCookieName, JSON.stringify({necessary: true, statistic: analytics, marketing: ads} as ICookies))
}

export const writeCookie = (cookieName: string, value: string, expires: number|null = null, domain?: string, secure?: boolean) => {
    const isProd = (process.env.NODE_ENV === 'production')
    if (!expires || expires <= 0) {
        expires = 365
    }
    if (!domain) {
        if (isProd) {
            domain = "megatelco.be"
        } else {
            domain = window.location.hostname
        }
    }
    if (typeof secure === 'undefined') {
        secure = isProd
    }
    
    if (process.env.VUE_APP_COOKIE_NATIVE) {
        const expirationDate = new Date()
        expirationDate.setDate(expirationDate.getDate()+expires)

        let paramsStr = `Expires=${expirationDate.toUTCString()};`
        paramsStr += ` Domain=${domain};`
        paramsStr += ` Path=/;`
        paramsStr += ` SameSite=Lax;`
        if (secure) {
            paramsStr += ` Secure`
        }
        
        document.cookie = `${cookieName}=${value}; ${paramsStr}`
    } else {
        Cookies.set(cookieName, value, {
            expires: expires,
            domain: domain,
            secure: secure,
            sameSite: 'Lax',
            path: "/"
        })
    }
    
    const json = JSON.parse(value) as ICookies

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: "cookiesAcceptation",  
        cookiesNecessary: "accepted",
        cookiesStatistic: json.statistic ? "accepted" : "declined",  
        cookiesMarketing: json.marketing ? "accepted" : "declined"
    })
}